import { CheckCircle2 } from 'lucide-react'
import { Modal } from '@shared/ui/Modal'
import { Button } from '@shared/ui/Button'
import { ENV } from '@shared/config/env'
import styles from './AutoRenewDisabledResultModal.module.css'

interface AutoRenewDisabledResultModalProps {
  /** Дата окончания/следующего списания в локальном формате — для подстановки в текст */
  expiresAtFormatted?: string | null
  /** Что произошло: автопродление выключили или включили. По умолчанию — выключили. */
  mode?: 'enabled' | 'disabled'
  onClose: () => void
}

/**
 * Result-модалка после успешного `setAutoRenew`.
 * mode='disabled' — сообщает, что доступ сохранится до даты окончания.
 * mode='enabled'  — сообщает, что подписка будет продлеваться, и дату списания.
 */
export const AutoRenewDisabledResultModal = ({
  expiresAtFormatted,
  mode = 'disabled',
  onClose,
}: AutoRenewDisabledResultModalProps) => {
  const variant = ENV.IS_TG ? 'bottomSheet' : 'center'

  const title =
    mode === 'enabled' ? 'Автопродление подключено' : 'Подписка отменена'
  const text =
    mode === 'enabled'
      ? expiresAtFormatted
        ? `Подписка будет продлеваться автоматически. Следующее списание — ${expiresAtFormatted}.`
        : 'Подписка будет продлеваться автоматически.'
      : expiresAtFormatted
        ? `Доступ сохранится до ${expiresAtFormatted}. После этого подписка не продлится.`
        : 'Доступ сохранится до конца текущего периода. После этого подписка не продлится.'

  return (
    <Modal onClose={onClose} variant={variant} showClose>
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <CheckCircle2 size={36} />
        </div>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.text}>{text}</p>
        <div className={styles.actions}>
          <Button onClick={onClose} block>ОК</Button>
        </div>
      </div>
    </Modal>
  )
}
